import React, { useState } from 'react';
import { useSearchParams, Link as RouterLink } from 'react-router-dom';
import {
  Container, Box, Typography, TextField, Button, Card, CardContent,
  Alert, Link,
} from '@mui/material';
import { authService } from '../../services/authService';

const ForgotPasswordPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const userType = searchParams.get('type') === 'company' ? 'company' : 'athlete';
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authService.forgotPassword(email, userType);
      setSent(true);
    } catch (err: any) {
      setError(err.response?.data?.message || 'エラーが発生しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5', py: 6 }}>
      <Container maxWidth="sm">
        <Card>
          <CardContent sx={{ p: 4 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, textAlign: 'center' }}>
              パスワードリセット
            </Typography>
            <Typography variant="body2" sx={{ mb: 3, textAlign: 'center', color: '#666' }}>
              登録済みのメールアドレスを入力してください。パスワードリセットのリンクをお送りします。
            </Typography>

            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            {sent ? (
              <Alert severity="success" sx={{ mb: 2 }}>
                メールアドレスが登録されている場合、パスワードリセットメールを送信しました。メールをご確認ください。
              </Alert>
            ) : (
              <Box component="form" onSubmit={handleSubmit}>
                <TextField
                  label="メールアドレス"
                  type="email"
                  fullWidth
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  sx={{ mb: 3 }}
                />
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  size="large"
                  disabled={loading}
                >
                  {loading ? '送信中...' : 'リセットメールを送信'}
                </Button>
              </Box>
            )}

            <Box sx={{ mt: 3, textAlign: 'center' }}>
              <Typography variant="body2">
                <Link component={RouterLink} to={userType === 'company' ? '/auth/company-login' : '/auth/athlete-login'}>
                  ログインに戻る
                </Link>
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default ForgotPasswordPage;
